import { MakeCall } from 'ha/services/apiV2/createMakeCall';
import { APIV2_URL } from './constants';

interface VerificationRequest {
  email: string;
  phone: string;
  phoneCountryCode: string;
  comments: string;
}

export default (makeCall: MakeCall) =>
  (userId: number, data: VerificationRequest) =>
    makeCall('POST', `${APIV2_URL}/user/${userId}/verify-manually`, {
      data,
    });
